export function IconSetupPosition({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
    >
      <path
        fill="currentColor"
        d="M1 1h6v6H1zm1.5 1.5v3h3v-3zM9 1h6v6H9zM1 9h6v6H1zm8 0h6v6H9zm1.5 1.5v3h3v-3z"
      />
    </svg>
  );
}
